import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import Cookies from 'react-cookies';
import { PINK_GIFT } from '../../config/constants/images';
import cookies from '../../config/cookies/cookies';
import {
  FIND_GIFT_NOW_BUTTON,
  FIND_YOUR_PERFECT_GIFT,
} from '../../config/text/text';
import useCheckMobile from '../../helpers/checkMobile';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import CTAButton from '../_generic/button/CTAButton';

const GiftingBanner = ({ subText }) => {
  const theme = useContext(ThemeContext);
  const locationCookie = Cookies.load(cookies.location);
  const redirectUrl = `deal/${locationCookie?.shortName}/gift-finder`;
  const router = useRouter();
  const isMobile = useCheckMobile(false);

  const handleClick = () => {
    redirectToURL(redirectUrl, router);
  };

  return (
    <>
      <div className="giftbanner-container">
        <div className="container">
          <div className={classNames('row', { 'row-reverse': isMobile })}>
            <div className="col-3" />
            <div className="col-9">
              <div className="giftbanner">
                <h1 className="giftfinder-text">{FIND_YOUR_PERFECT_GIFT}</h1>
                <p className="giftfinder-subtext">{subText}</p>
                <CTAButton
                  className={'gifts-banner-button'}
                  onClick={handleClick}
                  primaryAction={false}
                >
                  {FIND_GIFT_NOW_BUTTON}
                </CTAButton>
              </div>
            </div>
          </div>
        </div>

        <style jsx>
          {`
            .giftbanner-container {
              background-color: ${theme.colors.headergiftfinderbackground};
              background-image: url(${PINK_GIFT});
              background-position: 138% 0%;
              background-repeat: no-repeat;
              background-size: 200px;
              padding: 15px 10px;
              width: calc(100% + 30px);
              margin-left: -15px;
            }
            .giftfinder-text {
              font-family: Helvetica, Arial, sans-serif;
              font-weight: bold;
              margin-bottom: 0;
              text-transform: capitalize;
              color: white;
              font-size: 22px;
            }
            .giftfinder-subtext {
              display: block;
              padding: 0 0 15px 0;
              font-size: 16px;
              margin-bottom: 0;
              color: white;
            }
            .row-reverse {
              flex-direction: row-reverse;
            }
            @media (min-width: ${theme.breakpoints.smUp}) {
              .giftfinder-subtext {
                font-size: 18px;
              }
            }
            @media (min-width: ${theme.breakpoints.mdUp}) {
              .giftbanner-container {
                background-position: 20px 0;
                background-size: contain;
                padding: 15px 30px;
                text-align: center;
                width: 100%;
                margin-left: 0;
              }
              .giftbanner {
                width: 90%;
              }
              .giftfinder-text {
                font-size: 25px;
              }
            }
            @media (min-width: ${theme.breakpoints.lgUp}) {
              .giftbanner-container {
                padding: 15px 50px;
                background-position: 40px 0;
              }
              .giftfinder-text {
                font-size: 35px;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export default GiftingBanner;
